export default {"src":"/_next/static/media/phone.122e8cc4.svg","height":24,"width":24};